<template>
       <el-card shadow="hover" class="bikeCard">
        <div slot="header" class="clearfix">
          <img :src="BiconImg" alt="icon" class="mapIcon"/>
          <span>{{title}}</span>
       </div>
       <div>
         {{msg}}
         <el-button type="primary" class="MapViewBtn" @click="showArea">{{$t('message.clickView')}}</el-button>
         <div>{{t1==1?$t('message.mianji'):$t('message.numsg')}}</div>
         </div>
      </el-card>
 
</template>

<script>
export default {
  name: "ElectricFCard",
  props: ["title", "msg", "t1"],
  data() {
    return {};
  },
  created() {
    // console.log(this.t1);
  },
  computed: {
    BiconImg() {
      var imgUrl = require("../assets/2.png");
      if (this.t1 == 1) {
        return imgUrl;
      } else if (this.t1 == 2) {
        imgUrl = require("../assets/3.png");
        return imgUrl;
      } else if (this.t1 == 3) {
        imgUrl = require("../assets/4.png");
        return imgUrl;
      } else {
        imgUrl = require("../assets/sqtcd.png");
        return imgUrl;
      }
    }
  },
  methods: {
    showArea() {
      if (this.t1 == 1) {
        this.$emit("areaSHow", 1);
      } else if (this.t1 == 2) {
        this.$emit("areaSHow", 2);
      } else if (this.t1 == 3) {
        this.$emit("areaSHow", 3);
      } else {
        this.$emit("areaSHow", 4);
      }
    }
  }
};
</script>
<style>
.bikeCard {
  margin-bottom: 10px;
}

.MapViewBtn {
  float: right;
}
.mapIcon {
  vertical-align: middle;
  margin-right: 8px;
}
</style>
